import React from "react";
import {CardContainer, Container, Header} from "./Contact.css";
import {Card} from "@elcimai/webankdesignsystem";

function Contact() {
    return (
        <div className={Container}>
            <h1 className={Header}>Besoin d'aide ?</h1>
            <p className={Header}>Nos experts se feront un plaisir de répondre à vos questions.</p>
            <Card>
                <div className={CardContainer}>
                    <h1>Votre demande</h1>
                    <h4>Merci de bien vouloir préciser les informations suivantes lors de toute question ou demande
                        d’implémentation de nos API :</h4>
                    <p><b>1. Votre nom </b>: Indiquez votre nom complet.</p>
                    <p><b>2. Entreprise </b>: Mentionnez le nom de l'entreprise pour laquelle vous travaillez.</p>
                    <p><b>3. Référence légale </b>: Fournissez votre référence légale, par exemple : PSDFR-ACPR-XXXXX.</p>
                    <p><b>Envoyez ensuite votre demande à l'adresse suivante </b>: <a href="mailto:tpp@credit-municipal-services.fr">tpp@credit-municipal-services.fr</a></p>
                    <p>Cela nous permettra de traiter votre demande de manière efficace et rapide. </p>
                    <p>Merci de votre collaboration.</p>
                </div>

            </Card>
        </div>
    );
}

export default Contact;